export const NumberFieldAllowedKeys = [
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'Tab',
  '-',
  '.',
  ',',
];
